import type { FilterState } from "@/utils/drama";
import { countActiveFilters, toggleValue } from "@/utils/drama";

export const categoryChoices = [
  { value: "movie", label: "电影" },
  { value: "tv", label: "电视剧" },
];

export const yearChoices = [
  { value: "all", label: "全部年份" },
  { value: "2024", label: "2024" },
  { value: "2023", label: "2023" },
  { value: "2022", label: "2022" },
  { value: "2021", label: "2021" },
  { value: "2020", label: "2020" },
  { value: "2010s", label: "2010-2019" },
  { value: "2000s", label: "2000-2009" },
];

interface FilterPanelProps {
  filters: FilterState;
  genres: string[];
  onChange: (next: FilterState) => void;
  onReset: () => void;
  resultCount: number;
}

export default function FilterPanel({
  filters,
  genres,
  onChange,
  onReset,
  resultCount,
}: FilterPanelProps) {
  const activeCount = countActiveFilters(filters);

  return (
    <div className="w-full">
      <div className="flex items-center justify-between gap-3 border-b border-background-200 pb-3">
        <h2 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
          <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-100 text-primary-700">
            <i className="ri-filter-3-line text-sm" />
          </span>
          筛选条件
          {activeCount > 0 ? (
            <span className="rounded-full bg-accent-500 px-1.5 py-0.5 text-[10px] font-medium text-background-50">
              {activeCount}
            </span>
          ) : null}
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="flex items-center gap-1 text-xs text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-refresh-line" />
          重置
        </button>
      </div>

      <div className="mt-5">
        <h3 className="mb-2.5 text-xs font-medium text-foreground-600">影视形式</h3>
        <div className="flex flex-wrap gap-2">
          {categoryChoices.map((item) => {
            const active = filters.categories.includes(item.value);
            return (
              <button
                key={item.value}
                type="button"
                onClick={() =>
                  onChange({ ...filters, categories: toggleValue(filters.categories, item.value) })
                }
                className={`rounded-md border px-3 py-1.5 text-xs transition-colors cursor-pointer whitespace-nowrap ${
                  active
                    ? "border-primary-600 bg-primary-600 text-background-50"
                    : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300"
                }`}
              >
                {item.label}
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-5">
        <h3 className="mb-2.5 text-xs font-medium text-foreground-600">类型（可多选）</h3>
        <div className="flex flex-wrap gap-2">
          {genres.map((genre) => {
            const active = filters.genres.includes(genre);
            return (
              <button
                key={genre}
                type="button"
                onClick={() => onChange({ ...filters, genres: toggleValue(filters.genres, genre) })}
                className={`rounded-md border px-2.5 py-1.5 text-xs transition-colors cursor-pointer whitespace-nowrap ${
                  active
                    ? "border-primary-600 bg-primary-600 text-background-50"
                    : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300"
                }`}
              >
                {genre}
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-5">
        <h3 className="mb-2.5 text-xs font-medium text-foreground-600">上映年份</h3>
        <div className="grid grid-cols-4 gap-2">
          {yearChoices.map((item) => {
            const active = filters.year === item.value;
            return (
              <button
                key={item.value}
                type="button"
                onClick={() => onChange({ ...filters, year: item.value })}
                className={`rounded-md border py-1.5 text-xs transition-colors cursor-pointer whitespace-nowrap ${
                  active
                    ? "border-primary-600 bg-primary-600 text-background-50"
                    : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300"
                }`}
              >
                {item.label}
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-6 rounded-lg bg-background-100 p-3.5">
        <p className="flex items-center justify-between text-xs text-foreground-700">
          <span>当前结果</span>
          <span className="font-heading text-base font-black text-primary-700">{resultCount}</span>
        </p>
        <p className="mt-1 text-[11px] leading-relaxed text-foreground-500">
          筛选在页面内即时生效，不会跳转到其他页面。
        </p>
      </div>
    </div>
  );
}